import axios from "axios";

import { baseApiUrl } from "../General/Constants";

import localStorageProvider from '../Providers/LocalStorageProvider';

export const updateAll = (data: any) => {
  const url = `${baseApiUrl}/customer/private/payment/updateAll`;
  const token = localStorageProvider.getItem("token");
  const auth = { headers: { Authorization: `Bearer ${token}` } };

  return axios.post(url, data, auth).then(({ data }) => ({ data }));
};
